// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"59a1cc57","689":"ea694517"}[chunkId] + ".css";
};